/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Download: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="download" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M283.3333333333333 453.3333333333334V283.3333333333335H1076.6666666666665V453.3333333333334H1190V283.3333333333335C1190 221 1139 170 1076.6666666666665 170H170V453.3333333333334H283.3333333333333zM736.6666666666666 642.0333333333334L883.4333333333333 788.2333333333333L963.3333333333331 708.3333333333334L680 425L396.6666666666667 708.3333333333334L476.5666666666667 788.2333333333333L623.3333333333333 642.0333333333334V1190H736.6666666666666V642.0333333333334z" : "M226.6666666666667 362.6666666666667V226.6666666666667H861.3333333333334V362.6666666666667H952V226.6666666666667C952 176.7999999999999 911.2000000000002 136 861.3333333333334 136H136V362.6666666666667H226.6666666666667zM589.3333333333334 513.6266666666667L706.7466666666667 630.5866666666666L770.6666666666667 566.6666666666666L544 340L317.3333333333334 566.6666666666666L381.2533333333334 630.5866666666666L498.6666666666667 513.6266666666667V952H589.3333333333334V513.6266666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Download.displayName = `Blueprint5.Icon.Download`;
export default Download;
